module.exports = __webpack_public_path__ + "static/img/shangbiaozhuanrang@2x.bde31743.png";